import { ModalOverlayStyle, ModalSize } from '@interfaces/common/common.interface';

export class ModalConfig<D = any> {
  data?: D;
  size?: ModalSize = ModalSize.DEFAULT;
  style?: ModalOverlayStyle = 'default';
  // Configs are passed as object literals, so this default is not applied -
  // ModalComponent treats anything but an explicit false as true.
  closeOnOverlayClick?: boolean = true;
}
